import {
  VariantButton,
  VariantButtonProps,
} from 'components/atoms/Form/VariantButton';
import PreFilledByAITooltip from 'components/atoms/PreFilledByAITooltip.component';
import type { FC } from 'react';
import { getTracingEvents } from 'utils/amplitude';
import type { TracingConfig } from 'utils/amplitude/amplitude.types';

type Value = string | number | boolean | null;

export type VariantSelectionProps = {
  options: {
    label: any;
    value: Value;
    iconSrc?: string;
    isDisabled?: boolean;
    isSelected?: boolean;
  }[];
  value?: Value;
  onChange: (value: Value) => void;
  isDisabled?: boolean;
  tracing?: TracingConfig;
  buttonClassName?: string;
  iconClassName?: string;
  getButtonClassName?: (selected: boolean) => string;
  color?: VariantButtonProps['color'];
  aiTooltip?: {
    enabled?: boolean;
    description?: string | null;
  };
};

const VariantSelection: FC<VariantSelectionProps> = ({
  options,
  value: selected,
  onChange,
  isDisabled: disabled,
  tracing,
  aiTooltip,
  ...rest
}) => {
  const tracingEvents = getTracingEvents(tracing, { onChange });

  return (
    <>
      {options.map(({ value, label, iconSrc, isDisabled, isSelected }) => {
        const isValueSelected = value === selected || isSelected;
        const isAiTooltipEnabled = isValueSelected && !!aiTooltip?.enabled;
        return (
          <PreFilledByAITooltip
            key={String(value)}
            enabled={isAiTooltipEnabled}
            description={isValueSelected ? aiTooltip?.description : undefined}
          >
            <VariantButton
              disabled={disabled || isDisabled}
              selected={isValueSelected}
              useAIColorScheme={isAiTooltipEnabled}
              iconSrc={iconSrc}
              onClick={() => {
                if (value !== selected && !isSelected) {
                  tracingEvents.onChange(value);
                }
              }}
              {...rest}
            >
              <>{label}</>
            </VariantButton>
          </PreFilledByAITooltip>
        );
      })}
    </>
  );
};

export default VariantSelection;
